import { useEffect } from 'react';

const useDocumentTitle = (title: string) => {
  useEffect(() => {
    document.title = title;
    return function cleanup() {
      document.title = 'Youth Work One';
    };
  }, []);
};

export default useDocumentTitle;
